/* ============================================================
   HORCERY — Buy box: mount-variant select, quantity, add-on toggle,
   add-to-cart. Progressive enhancement over a native /cart/add form.
   Supports both the mount-variant buybox and the older plan buybox.
   ============================================================ */
(function () {
  'use strict';

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-hz-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        document.querySelectorAll('[data-hz-cart-count-a11y]').forEach(function (el) {
          el.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
        });
      }).catch(function () {});
  }

  function renderDrawer(drawer, html) {
    try {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newInner = parsed.querySelector('#CartDrawer');
      var curInner = drawer.querySelector('#CartDrawer');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
      var srcInner = parsed.querySelector('.drawer__inner');
      var isEmpty = srcInner ? srcInner.classList.contains('is-empty') : false;
      drawer.classList.toggle('is-empty', isEmpty);
      var di = drawer.querySelector('.drawer__inner');
      if (di) di.classList.toggle('is-empty', isEmpty);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && !overlay.__hzBound && typeof drawer.close === 'function') {
        overlay.__hzBound = true;
        overlay.addEventListener('click', function () { drawer.close(); });
      }
    } catch (err) { /* leave drawer as-is; count still refreshes */ }
  }

  function openDrawer(drawer) {
    if (typeof drawer.open === 'function') drawer.open();
    else { drawer.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
  }

  function initBuy(section) {
    if (!section || section.__hzInit) return;
    section.__hzInit = true;

    var cta = section.querySelector('[data-hz-cta]');
    var form = section.querySelector('[data-hz-buy-form]');
    var idInput = form ? form.querySelector('input[name="items[0][id]"]') : null;

    var mounts = Array.prototype.slice.call(section.querySelectorAll('[data-hz-mount]'));
    var plans = Array.prototype.slice.call(section.querySelectorAll('[data-hz-plan]'));
    var addonInput = section.querySelector('[data-hz-addon]');
    var addonLabel = section.querySelector('[data-hz-addon-label], .hz-buy__addon');

    var priceAmountEls = Array.prototype.slice.call(section.querySelectorAll('[data-hz-price-amount]'));
    var qtyInput = section.querySelector('[data-hz-qty-input]');

    var selectedShort = cta ? cta.getAttribute('data-monthly') : '';
    var currentPrice = cta ? (cta.getAttribute('data-price') || '') : '';

    if (cta && !cta.getAttribute('data-label')) {
      cta.setAttribute('data-label', (cta.textContent.split(' · ')[0] || 'Add to Cart').trim());
    }

    function updateCta() {
      if (!cta) return;
      var base = cta.getAttribute('data-label') || 'Add to Cart';
      var txt = base + ' · ' + currentPrice;
      if (plans.length && selectedShort) txt += ' + ' + selectedShort;
      cta.textContent = txt;
    }

    // ---- Mount variant selection (radios; value = variant id, data-price = money) ----
    mounts.forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        if (!input.checked) return;
        mounts.forEach(function (l) { l.classList.toggle('is-selected', l === label); });
        if (idInput && input.value) idInput.value = input.value;
        var p = input.getAttribute('data-price');
        if (p) {
          currentPrice = p;
          if (cta) cta.setAttribute('data-price', p);
          priceAmountEls.forEach(function (el) { el.textContent = p; });
        }
        updateCta();
      });
    });

    // ---- Quantity stepper ----
    if (qtyInput) {
      section.querySelectorAll('[data-hz-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-hz-qty-step')) || 0;
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + dir);
          qtyInput.value = v;
        });
      });
    }

    // ---- Plan selection (legacy support) ----
    plans.forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        plans.forEach(function (l) { l.classList.toggle('is-selected', l === label); });
        selectedShort = input.getAttribute('data-short') || selectedShort;
        updateCta();
      });
    });

    // ---- Add-on toggle ----
    if (addonInput && addonLabel) {
      addonInput.addEventListener('change', function () {
        addonLabel.classList.toggle('is-added', addonInput.checked);
        var plus = addonLabel.querySelector('[data-hz-addon-plus], .hz-buy__addon-plus');
        if (plus) plus.textContent = addonInput.checked ? '✓' : '+';
      });
    }

    // ---- Add-on quick-add (single-variant add-on: add immediately) ----
    var quickAdd = section.querySelector('[data-hz-addon-quickadd]');
    if (quickAdd) {
      quickAdd.addEventListener('click', function () {
        var vid = quickAdd.getAttribute('value');
        if (!vid) return;
        if (!window.fetch) { window.location = '/cart'; return; }
        quickAdd.setAttribute('aria-busy', 'true');
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(vid), quantity: 1 }] };
        if (drawer) { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); }).then(function (res) {
            if (res && res.status && Number(res.status) >= 400) { throw new Error('add failed'); }
            updateCartCount();
            quickAdd.innerHTML = '<span class="hz-buy__addon-plus" data-hz-addon-plus>✓</span> Added to cart';
            var card = quickAdd.closest('.hz-buy__addon'); if (card) card.classList.add('is-added');
            if (drawer && res.sections && res.sections['cart-drawer']) { renderDrawer(drawer, res.sections['cart-drawer']); openDrawer(drawer); }
            else if (drawer) { openDrawer(drawer); }
            else { window.location = '/cart'; }
          }).catch(function () { window.location = '/cart'; })
          .then(function () { quickAdd.removeAttribute('aria-busy'); });
      });
    }

    // ---- Add-on two-step picker (multi-variant add-on: choose -> pick -> add) ----
    var addonCard = section.querySelector('[data-hz-addon-card]');
    if (addonCard) {
      var chooseBtn = addonCard.querySelector('[data-hz-addon-choose]');
      var panel = addonCard.querySelector('[data-hz-addon-panel]');
      var addonVars = Array.prototype.slice.call(addonCard.querySelectorAll('[data-hz-addon-variant]'));
      var totalEl = addonCard.querySelector('[data-hz-addon-total]');
      var addonCartBtn = addonCard.querySelector('[data-hz-addon-cart]');
      var selAddonId = null, selAddonPrice = '';
      var checkedAV = addonCard.querySelector('[data-hz-addon-variant] input:checked');
      if (checkedAV) { selAddonId = checkedAV.value; selAddonPrice = checkedAV.getAttribute('data-price') || ''; }
      if (chooseBtn && panel) {
        chooseBtn.addEventListener('click', function () {
          var willOpen = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', willOpen);
          chooseBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          chooseBtn.classList.toggle('is-open', willOpen);
        });
      }
      addonVars.forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        input.addEventListener('change', function () {
          if (!input.checked) return;
          addonVars.forEach(function (l) { l.classList.toggle('is-selected', l === label); });
          selAddonId = input.value;
          selAddonPrice = input.getAttribute('data-price') || '';
          if (totalEl) totalEl.textContent = selAddonPrice;
        });
      });
      if (addonCartBtn) {
        addonCartBtn.addEventListener('click', function () {
          if (!selAddonId) return;
          if (!window.fetch) { window.location = '/cart'; return; }
          addonCartBtn.setAttribute('aria-busy', 'true');
          var drawer = document.querySelector('cart-drawer');
          var body = { items: [{ id: Number(selAddonId), quantity: 1 }] };
          if (drawer) { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
            .then(function (r) { return r.json(); }).then(function (res) {
              if (res && res.status && Number(res.status) >= 400) { throw new Error('add failed'); }
              updateCartCount();
              if (drawer && res.sections && res.sections['cart-drawer']) { renderDrawer(drawer, res.sections['cart-drawer']); openDrawer(drawer); }
              else if (drawer) { openDrawer(drawer); }
              else { window.location = '/cart'; }
            }).catch(function () { window.location = '/cart'; })
            .then(function () { addonCartBtn.removeAttribute('aria-busy'); });
        });
      }
    }

    // ---- Add to cart ----
    if (form && idInput) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // native fallback
        e.preventDefault();
        var deviceId = idInput.value;
        if (!deviceId) return;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var item = { id: Number(deviceId), quantity: qty };

        var selectedPlan = section.querySelector('[data-hz-plan] input:checked');
        if (selectedPlan) {
          var planLabel = selectedPlan.closest('[data-hz-plan]');
          var planNameEl = planLabel ? planLabel.querySelector('.hz-buy__plan-name, [data-hz-plan-name]') : null;
          item.properties = { Plan: planNameEl && planNameEl.textContent ? planNameEl.textContent.trim() : selectedPlan.value };
        }
        var items = [item];
        if (addonInput && addonInput.checked && addonInput.value) {
          items.push({ id: Number(addonInput.value), quantity: 1 });
        }

        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer) { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
        if (cta) cta.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status && Number(res.status) >= 400) { throw new Error(res.description || 'add failed'); }
          updateCartCount();
          if (drawer && res.sections && res.sections['cart-drawer']) {
            renderDrawer(drawer, res.sections['cart-drawer']);
            openDrawer(drawer);
          } else if (drawer) {
            openDrawer(drawer);
          } else {
            window.location = '/cart';
          }
        }).catch(function () { window.location = '/cart'; })
          .then(function () { if (cta) cta.removeAttribute('aria-busy'); });
      });
    }
  }

  function initGallery(g) {
    if (g.__hzG) return;
    if (g.classList.contains('hz-pdp-buy__stage')) return; // hz-pdp-buy.js owns that gallery
    g.__hzG = true;
    var track = g.querySelector('[data-hz-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var nav = g.querySelector('.hz-buy__gnav, .hz-pdp-buy__nav');
    if (!track || slides.length <= 1) { if (nav) nav.style.display = 'none'; return; }
    var dotsWrap = g.querySelector('[data-hz-gallery-dots]');
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        d.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
        if (i === 0) d.className = 'is-active';
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function go(dir) { track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' }); }
    var prev = g.querySelector('[data-hz-gallery-prev]');
    var next = g.querySelector('[data-hz-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  }

  // ---- Thumbnail-strip gallery (optional style): thumbs + dots drive the main image ----
  function initThumbs(thumbsEl) {
    if (!thumbsEl || thumbsEl.__hzT) return; thumbsEl.__hzT = true;
    var gallery = thumbsEl.closest('.hz-buy__gallery');
    var track = gallery && gallery.querySelector('[data-hz-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.hz-buy__slide'));
    function slideBase() { return slides.length ? slides[0].offsetLeft : 0; }
    function nearestIndex() {
      var b = slideBase(), sl = track.scrollLeft, best = 0, bestD = Infinity;
      slides.forEach(function (s, k) { var d = Math.abs((s.offsetLeft - b) - sl); if (d < bestD) { bestD = d; best = k; } });
      return best;
    }
    var thumbs = Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-hz-thumb]'));
    var strip = thumbsEl.querySelector('[data-hz-thumbs-track]');
    var tprev = thumbsEl.querySelector('[data-hz-thumbs-prev]');
    var tnext = thumbsEl.querySelector('[data-hz-thumbs-next]');
    var dotsWrap = gallery.querySelector('[data-hz-thumb-dots]');
    var dots = [];
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i) {
      if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - slideBase(), behavior: 'smooth' });
      mark(i);
      var t = thumbs[i];
      if (t && strip) { strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2), behavior: 'smooth' }); }
    }
    if (dotsWrap) {
      thumbs.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { mark(nearestIndex()); ticking = false; });
    }, { passive: true });
    if (tprev && strip) tprev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.7, behavior: 'smooth' }); });
    if (tnext && strip) tnext.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.7, behavior: 'smooth' }); });
  }

  function initAll() {
    document.querySelectorAll('[data-hz-buy]').forEach(initBuy);
    document.querySelectorAll('[data-hz-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-hz-thumbs]').forEach(initThumbs);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-buy]');
    if (el) { el.__hzInit = false; initBuy(el); }
    e.target.querySelectorAll('[data-hz-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hz-thumbs]').forEach(initThumbs);
  });

  /* Mount help link -> open + scroll to the mounts accordion */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-hz-mount-help]');
    if (!btn) return;
    var acc = document.querySelector('[data-hz-acc-mounts]');
    if (!acc) return;
    acc.open = true;
    acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

})();
